module.exports = __webpack_public_path__ + "static/media/433634617_1012166690512854_9104328487584770999_n.bc41589f.jpg";